import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { ReplaceSeniorityMatrixPayload } from '../types';

/** Full replace (delete-then-insert on the backend). */
export function useUpdateSeniorityMatrix() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;
  const { t } = useTranslation('timeOff');
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: ReplaceSeniorityMatrixPayload) =>
      timeOffService.updateSeniorityMatrix(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.seniorityMatrix(orgId) });
      toast.success({ title: t('settings.toasts.matrixSaved') });
    },
  });
}
